
import { Footer } from '../../components/share/Footer';
import { NavbarComponent } from "../../components/share/NavbarComponent";
import { HeadTitle } from "../../components/share/HeadTitle";
// import { CreateAttatchFileFormTestComponent } from '../../components/Officer/CreateAttatchFileFormTestComponent';
import { CreateAttatchFileFormTrainComponent } from '../../components/Officer/CreateAttatchFileFormTrainComponent';
import React from 'react'

export const CreateAttatchFileFormTrainContainer = () => {
  const titleName = "แผนที่ตั้งของสถานที่ดำเนินการฝึกอบรม";
  return (
    <div className="page-container bg-landing">

      <NavbarComponent />
      <HeadTitle title={titleName} />
      <CreateAttatchFileFormTrainComponent />
      <Footer />
    </div>
  );
}
